import { PlusCircleIcon, SquaresPlusIcon } from "@heroicons/react/24/outline";
import CanceledCochesIcon from "../../components/shared/icons/canceledCoaches";
import ShipIcon from "../../pages/CallCenter/Icons/ShipIcon";

const ShipBooking = [
    {
        path: "ship-booking",
        fullPath: "call-center/ship-booking",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Ship Booking",
        displayPath: "Call Center > Ship Booking",
        icon: ShipIcon,
        children: [
            {
                path: "new",
                fullPath: "call-center/ship-booking/new",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "New",
                displayPath: "Call Center > Ship Booking > New",
                icon: PlusCircleIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Booking/ShipBookingCreate"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-ship-booking-create"],
                    },
                ],
            },
            {
                path: "manage",
                fullPath: "call-center/ship-booking/manage",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Manage",
                displayPath: "Call Center > Ship Booking > Manage",
                icon: SquaresPlusIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Manage/Ship"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-booking-manage"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Manage/Details"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["callcenter-ship-booking-manage"],
                    },
                ],
            },
            // {
            //     path: "canceled-coaches",
            //     fullPath: "call-center/ship-booking/canceled-coaches",
            //     exact: true,
            //     showChildren: false,
            //     sidebarMenu: true,
            //     displayName: "Canceled Coaches",
            //     displayPath: "Call Center > Ship Booking > canceled-coaches",
            //     icon: CanceledCochesIcon,
            //     children: [
            //         {
            //             index: true,
            //             async lazy() {
            //                 const component = await import(
            //                     "../../pages/CallCenter/Booking/CanceledCoaches/List"
            //                 );
            //                 return {
            //                     Component: component.default,
            //                 };
            //             },
            //             permissions: ["callcenter-ship-booking-cancelled-coaches"],
            //         },
            //     ],
            // },
        ],
    },
];

export default ShipBooking;
